import React from 'react';
import { Plug, Repeat, Cpu, Bot, ClipboardList, HeadphonesIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function IntegrationFeatures() {
  const { t } = useTranslation();

  const features = [
    { icon: Plug,           key: 'singleApi',  color: '#8B5CF6' },
    { icon: Repeat,         key: 'realtime',   color: '#3ECF8E' },
    { icon: Bot,            key: 'mcp',        color: '#a78bfa' },
    { icon: Cpu,            key: 'mapping',    color: '#f59e0b' },
    { icon: ClipboardList,  key: 'audit',      color: '#f472b6' },
    { icon: HeadphonesIcon, key: 'support',    color: '#38bdf8' },
  ] as const;

  return (
    <div className="relative bg-[#0d1523] py-28 overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#8B5CF6] opacity-[0.04] blur-[100px] rounded-full pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white mb-5 leading-tight">
            {t('integrationFeatures.title')}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            {t('integrationFeatures.subtitle')}
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map(({ icon: Icon, key, color }) => (
            <div
              key={key}
              className="group relative bg-[#111827] border border-white/5 rounded-2xl p-8 hover:border-white/10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl overflow-hidden"
            >
              {/* Card inner glow on hover */}
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"
                style={{ background: `radial-gradient(400px circle at 50% 0%, ${color}08, transparent 70%)` }}
              />

              {/* Icon */}
              <div
                className="relative inline-flex items-center justify-center w-12 h-12 rounded-xl mb-5"
                style={{ backgroundColor: `${color}18`, border: `1px solid ${color}30` }}
              >
                <Icon className="h-5 w-5" style={{ color }} />
              </div>

              {/* Text */}
              <h3 className="relative text-lg font-semibold text-white mb-3">
                {t(`integrationFeatures.features.${key}.title`)}
              </h3>
              <p className="relative text-gray-400 text-sm leading-relaxed">
                {t(`integrationFeatures.features.${key}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
